import { UIEventHandler, useRef } from 'react';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { Target } from 'typings/api/shareTradeTarget';
import UserItem from '../UserItem';
import { UserListWrapper } from './styled';

export interface UserItemTarget extends Target {
  is_shared?: boolean;
}

interface UserListProps {
  className?: string;
  defaultCheckedKey?: string;
  sharedDescription?: string;
  data?: UserItemTarget[];
  disableSharedKey?: string[];
  disableSharedUsers?: boolean;
  onSelectedUserChange?(isSelected: boolean, userTarget: Target): void;
  onScrollToBottom?(): void;
}

const UserList = ({
  className,
  defaultCheckedKey = '',
  sharedDescription = 'Already shared to this friend',
  data = [],
  disableSharedKey = [],
  disableSharedUsers = false,
  onSelectedUserChange = () => {},
  onScrollToBottom = () => {},
}: UserListProps) => {
  const isAllowScrollTrigger = useRef(false);

  const getIsDisabled = (target: UserItemTarget): boolean => {
    if (!disableSharedUsers) return false;

    for (let i = 0; i < disableSharedKey.length; i += 1) {
      if (target[disableSharedKey[i]]) return true;
    }

    return false;
  };

  const handleUserChange = (e: CheckboxChangeEvent, userTarget: Target) => {
    const { checked } = e.target;
    onSelectedUserChange(checked, userTarget);
  };

  const handleScroll: UIEventHandler<HTMLDivElement> = (event) => {
    const { scrollHeight, scrollTop, clientHeight } = event.currentTarget;
    const scrollDistance = clientHeight + scrollTop;
    const isBottomScroll = scrollDistance > scrollHeight - 300;

    if (isBottomScroll && isAllowScrollTrigger.current) {
      isAllowScrollTrigger.current = false;
      onScrollToBottom();
      return;
    }

    if (!isBottomScroll && !isAllowScrollTrigger.current) {
      isAllowScrollTrigger.current = true;
    }
  };

  return (
    <UserListWrapper className={className} onScroll={handleScroll}>
      {data.map((item, idx) => {
        const isDisabled = getIsDisabled(item);
        return (
          <UserItem
            key={item.id}
            avatarUrl={item.avatar_url}
            name={item.name}
            alias={item.shortened_name}
            targetType={item.type}
            description={isDisabled ? sharedDescription : item.description}
            isVerified={item.is_verified}
            defaultChecked={item[defaultCheckedKey] || false}
            onCheckChange={(e) => handleUserChange(e, data[idx])}
            disabled={isDisabled}
          />
        );
      })}
    </UserListWrapper>
  );
};

export default UserList;
